
const validateEmail = (email) => {

    if (email.length === 0) return ({
        isValid: false,
        message: "Email field can't be empty"
    });

    // domain validations needs to be done here
    const regexEmail = /^[a-zA-Z0-9.!#$%+&'*\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,24}$/;
    let isValidEmail = regexEmail.test(email);

    return ({
        isValid: isValidEmail,
        message: isValidEmail ? "" : "Invalid credentials"
    });
}

const validatePassword = (password) => {
    if (password.length === 0) return ({
        isValid: false,
        message: "Password field can't be empty"
    });

    const isStrongPassword =
        (password.match(/[a-z]/g) &&
            password.match(/[A-Z]/g) &&
            password.match(/[0-9]/g) &&
            password.match(/[^a-zA-Z\d]/g) &&
            password.length >= 8);

    return ({
        isValid: isStrongPassword,
        message: isStrongPassword ?
            // "" : "Please enter a password having at least one uppercase, lowercase, number,special character and minimum length of 8"
            "":"Invalid credentials"
    });
}

const validatePhoneNumber = (number) => {
    if (number.length === 0) return ({
        isValid: false,
        message: "Phone number can't be empty"
    });
    const regexPhone = /(\+)?(91)?( )?[789]\d{9}$/;

    const isValidPhNum = regexPhone.test(number) && number.length === 10;

    return ({
        isValid: isValidPhNum,
        message: isValidPhNum ?
            "" : "Invalid Mobile Number"
    });
}

const validateUserType = (userType, domains, email) => {
    const domain = email.split('@')[1];
    let user = "";

    if (domain === domains.SEBIUSER)
        user = 'SEBIUSER';
    else if (domain === domains.KFIN || domain === domains.CAMS)
        user = 'APMII';
    else
        user = 'PMS';

    if (userType == user) {
        return ({
            isValid: true,
            message: ""
        })
    }
    else {
        return ({
            isValid: false,
            message: "Invalid User Type"
        })
    }
}

export default {
    validateEmail,
    validatePassword,
    validatePhoneNumber,
    validateUserType
}